export enum Events {
  CrmPersonsInteractionHistoryRefresh,
  NotificationEvent,
}

export interface NotificationEvent {
  title: string;
  body?: string;
  url?: string;
}
